module.exports = __webpack_public_path__ + "media/images/flags/ws-c127a6838f88dd6e276c5950b03229c4.svg";